// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t7us","left":"styles_left__2Fofs","desktopActions":"styles_desktopActions__2VObk","title":"styles_title__WN4hT"};